import { CmsEditableElementController } from "./CmsEditableElementController";
import type { CmsElementTypeMeta } from "./types";

export class CmsElementControllerFactory {
    constructor(
        private readonly elementTypes: Record<string, string> = {},
        private readonly elementTypeMeta: Record<string, CmsElementTypeMeta> = {},
    ) {}

    create(element: HTMLElement): CmsEditableElementController {
        return new CmsEditableElementController(element, this.elementTypes, this.elementTypeMeta);
    }
}
